/**
 * @description Simple alpha regex with spaces
 */
export const alphaRegex = /^[a-zA-Z\s]*$/

/**
 * @description Simple alphanumeric regex with spaces
 */
export const alphaNumericRegex = /^[A-Za-z0-9\s]*$/

/**
 * @description Simple numeric regex
 */
export const numericRegex = /^[0-9]*$/

/**
 * @description Simple Australian mobile number regex
 */
export const mobileNumberRegex = /^(04)\d+$/

/**
 * @description Simple name regex
 */
export const nameRegex = /^[^~`!@#$%^&*_+=?;[\]{}\\|/]*$/
